import React, { useState, useEffect } from 'react'
import '../css/general/Header.css';
import Logo from '../assets/logo2.png';
import { Link, NavLink } from 'react-router-dom';
import UserLogin from '../components/UserLogin';
import Cart from '../components/Cart';
import { useNavigate } from 'react-router-dom';

const Header = ({ isUser, setSearchQuery, userData }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
const [dMobile, setDMobile] = useState('9776244971');


    useEffect(() => {
        const fetchMobile = async () => {
            try {
                const response = await fetch(`https://api.kcmstore.in/store/admin-info`);
                if (response.ok) {
                    const data = await response.json();
                        setDMobile(data[0]['phone']);
                } else {
                    console.error('Failed to fetch products');
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchMobile();
    }, []);


  const handleScroll = () => {
    if (window.scrollY > 40) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleSearchChange = (event) => {
    setQuery(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    if (query.trim()) {
      navigate(`/shop?search=${query}`);
    }
  };

  useEffect(() => {
    // console.log(userData);
    if(userData != null){
    const updateCartFromStorage = async () => {
        const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
        setCart(sortedProducts || []);
        }

        // const savedCart = JSON.parse(localStorage.getItem('cart'));
        // setCart(savedCart || []);
    };

    // Initial load
    updateCartFromStorage();

    // Listen for custom "cartUpdated" event
    window.addEventListener('cartUpdated', updateCartFromStorage);

    
    return () => {
        window.removeEventListener('cartUpdated', updateCartFromStorage);
    };
  }
}, []);

  

  return (
    <>
      <header className={`header-bg sticky-top ${isScrolled ? 'scrolled' : ''}`}>
        <div className='container d-flex justify-content-between'>
          <div className='d-flex'>
          <img src={Logo} className='img-fluid cursor-pointer my-1 me-lg-5' onClick={() => navigate('/')} style={{ height: '4.2em' }} alt='Logo' />
<NavLink className='header-link align-content-center d-lg-block d-md-block d-none ms-5 my-4' activeClassName='active' to='/'>Home</NavLink>
<NavLink className='header-link align-content-center d-lg-block d-md-block d-none ms-5 my-4' activeClassName='active' to='/shop'>Shop</NavLink>
<NavLink className='header-link align-content-center d-lg-block d-md-block d-none ms-5 my-4' activeClassName='active' to='/privacy-policy'>Privacy Policy</NavLink>
<NavLink className='header-link align-content-center d-lg-block d-md-block d-none ms-5 my-4' activeClassName='active' to='/contact'>Contact</NavLink>
          </div>
          <div className='d-flex'>
            <span className='align-content-center d-lg-block d-md-block d-none'>
            <form onSubmit={handleSearchSubmit}>
              <div className='col-12 bg-white rounded-4 d-flex px-3' style={{opacity: '0.9'}}>
              <input
                type="text"
                value={query}
                onChange={handleSearchChange}
                className="form-input rounded-4 border-0"
                placeholder="Search.."
              />
              <i class="fa-solid fa-magnifying-glass text-darkblue py-3"></i>
              </div>
              </form>
            </span>
            <div className='mt-1 align-content-center'>
            <span className='d-lg-none d-md-none' onClick={() => setShowSearch(true)}><i class="fa-solid fa-magnifying-glass header-icon"></i></span>

              {!isUser && <span onClick={() => setShowForm(true)}><i class="fa-solid header-icon fa-user-plus mx-lg-3 mx-md-3 mx-4"></i></span>}

              {isUser && <span onClick={() => navigate('/checkout')} className='cart-num-area ms-lg-3 ms-md-3 mx-2 px-3'><span className='cart-num'>{cart.length}</span><i class="fa-solid header-icon fa-bag-shopping"></i></span>}

              {!isUser && <span className='d-lg-none d-md-none' onClick={() => setShowNav(true)}><i class="fa-solid fa-bars header-icon"></i></span>}
              </div>
          </div>
        </div>
      </header>

      {/* <ScrollToTop smooth className='scroll-to-top' viewBox="0 0 448 512"
        svgPath="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" /> */}


      {showForm && <UserLogin setShowForm={setShowForm} />}

      {showCart && <Cart setShowCart={setShowCart} userData={userData} />}

{showNav && (
  <>
          <section className='search-area animate__animated animate__slideInLeft animate__fast'>
          <span onClick={() => setShowNav(false)}><i class="fa-solid fa-square-xmark search-close text-white cursor-pointer"></i></span>

<div>
  <hr className='opacity-100 text-white' />
<NavLink className='header-link align-content-center' activeClassName='active' to='/'>Home</NavLink>
<hr className='opacity-100 text-white' />
<NavLink className='header-link align-content-center' activeClassName='active' to='/shop'>Shop</NavLink>
<hr className='opacity-100 text-white' />
<NavLink className='header-link align-content-center' activeClassName='active' to='/privacy-policy'>Privacy Policy</NavLink>
<hr className='opacity-100 text-white' />
<NavLink className='header-link align-content-center' activeClassName='active' to='/contact'>Contact</NavLink>
<hr className='opacity-100 text-white' />
</div>
</section>
  </>
)}

      {showSearch && (
        <>
        <section className='search-area animate__animated animate__fadeInTopRight animate__fast'>
          <span onClick={() => setShowSearch(false)}><i class="fa-solid fa-square-xmark search-close text-white cursor-pointer"></i></span>

          <form onSubmit={handleSearchSubmit}>
              <div className='col-12 bg-transparent rounded-pill d-flex'>
              <input
                type="text"
                value={query}
                onChange={handleSearchChange}
                className="search-input rounded-pill border-0"
                placeholder="Search.."
              />
              <i class="fa-solid fa-magnifying-glass text-white py-3 px-2 fs-4"></i>
              </div>
              <hr className='my-0 text-white opacity-100' />
              </form>

        </section>
        </>
      )}


      <div className='fixed-btn-area'>
        <button className='bg-darkblue text-light mb-3' onClick={()=> window.open(`tel:${dMobile}`)}><i class="fa-solid fa-phone"></i></button><br />
        <button className='bg-success text-light mb-3' onClick={() => window.open('https://wa.me/919776244971')}><i class="fa-brands fa-whatsapp fs-5"></i></button><br />
        <button className='bg-warning text-light' onClick={()=> window.open('tel:9692049594')}><i class="fa-solid fa-headset"></i></button>
      </div>

    </>
  )
}

export default Header
